angular.module('v3sWbtPlayerApp').factory('v3sManual', ["v3sModal", "v3sSupportedLanguages", "v3sWbtDataService", "$templateCache", function (v3sModal, v3sSupportedLanguages, v3sWbtDataService, $templateCache) {
    var modal = null;

    function show() {
        var lang = v3sWbtDataService.getWbt().language;
        if (!(lang in v3sSupportedLanguages)) {
            lang = "de";
        }

        var content = $templateCache.get('app/js/helper/manual/manual.' + lang + '.tpl.html');
        if (!!modal) {
            modal.hide();
            return;
        }
        modal = v3sModal.show({
            title: "dialogs.manual.title",
            content: content,
            onHide: function () {
                modal = null;
            }
        });
    }

    return {
        show: show
    }

}]);